// extracted by mini-css-extract-plugin
export default {"role":"HvW6_R","roleName":"EGDxBe"};